// JS for Help me choose
import $ from 'jquery'

function isSkippableField(field) {
	return field.classList.contains('gfield--type-hidden') ||
		field.classList.contains('gform_hidden') ||
		field.classList.contains('gfield_visibility_hidden')
}

function isStepImageField(field) {
	if (!field.classList.contains('gfield--type-html')) {
		return false
	}

	var content = field.querySelector('.gfield_html') || field

	if (!content.querySelector('img')) {
		return false
	}

	return content.textContent.trim().length === 0
}

function groupFieldsIntoSteps(fields) {
	var groups = []
	var body = []

	fields.forEach(function (field) {
		if (isStepImageField(field)) {
			groups.push({ body: body, media: field })
			body = []
		} else {
			body.push(field)
		}
	})

	if (body.length) {
		groups.push({ body: body, media: null })
	}

	return groups
}

function pairStepMedia(fieldsEl) {
	if (!fieldsEl || fieldsEl.querySelector(':scope > .hmc-step')) {
		return
	}

	var fields = Array.prototype.filter.call(fieldsEl.children, function (el) {
		return el.classList &&
			(el.classList.contains('gfield') || el.classList.contains('lead-form-wrapper')) &&
			!isSkippableField(el)
	})

	if (fields.length < 2) {
		return
	}

	var groups = groupFieldsIntoSteps(fields)

	if (!groups.some(function (group) { return group.media })) {
		return
	}

	groups.forEach(function (group) {
		var anchor = group.body[0] || group.media

		if (!anchor) {
			return
		}

		var row = document.createElement('div')
		row.className = 'hmc-step'
		fieldsEl.insertBefore(row, anchor)

		var bodyWrap = document.createElement('div')
		bodyWrap.className = 'hmc-step__body'
		group.body.forEach(function (el) { bodyWrap.appendChild(el) })
		row.appendChild(bodyWrap)

		if (group.media) {
			var mediaWrap = document.createElement('div')
			mediaWrap.className = 'hmc-step__media'
			mediaWrap.appendChild(group.media)
			row.appendChild(mediaWrap)
		}
	})

	Array.prototype.filter.call(fieldsEl.children, function (el) {
		return el.classList &&
			(el.classList.contains('gform_hidden') || el.classList.contains('gfield--type-hidden'))
	}).forEach(function (el) { fieldsEl.appendChild(el) })
}

function enhanceVisibleFieldGroups() {
	var scope = document.getElementById('wizard-form-container')

	if (!scope) {
		return
	}

	Array.prototype.forEach.call(scope.querySelectorAll('.gform_fields'), function (fieldsEl) {
		if (fieldsEl.offsetParent === null) {
			return
		}

		try {
			pairStepMedia(fieldsEl)
		} catch (e) {
			return
		}
	})
}

$(document).on('gform_page_loaded', function(event, form_id, current_page) {

	function move_progress_bar_to_bottom() {
		var $bar = $('div#gf_progressbar_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id);
		var $target = $('div#gform_wrapper_' + EAPLUS_VARS.hmc_wizard_form_id + ' .gform_page:visible .gform_page_fields');

		if (!$bar.length || !$target.length) {
			return;
		}

		$bar.each(function(i, e) {
			var progressBar = $('<div>').append($(e).clone()).remove().html();
			$target.append(progressBar);
			$(e).remove();
		});
	}

	if (form_id == EAPLUS_VARS.hmc_wizard_form_id) {
		move_progress_bar_to_bottom();
		enhanceVisibleFieldGroups();
	}

});

$(document).on('gform_post_render', function(event, form_id) {
	if (form_id == EAPLUS_VARS.hmc_wizard_form_id) {
		enhanceVisibleFieldGroups();
	}
});
